import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Pivot, PivotItem } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getGroupsLayoutStyles } from './styles';

export const GroupsLayoutControls = (props) => {
  const {
    i18n,
    groups,
    activeGroupKey,
    onChangeActiveGroupKey,
  } = props;
  const classes = useDefaultStyles(getGroupsLayoutStyles);

  if (groups.length === 1) return null;

  return (
    <div className={classnames('groups-controls', classes.controls)} >
      <Pivot
        selectedKey={activeGroupKey}
        onLinkClick={item => onChangeActiveGroupKey(item.props.itemKey)}
      >
        {
          _.map(groups, group => (
            <PivotItem
              key={group.key}
              itemKey={group.key}
              headerText={i18n.getString(group.label)}
            />
          ))
        }
      </Pivot>
    </div>
  );
};

GroupsLayoutControls.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  activeGroupKey: PropTypes.string.isRequired,
  onChangeActiveGroupKey: PropTypes.func.isRequired,
};
